export default __webpack_public_path__ + "static/media/080_finish_soso.vp9.41e3eb1d.webm";